<template>
  <div class="joinRequest">
    <user-photo
      class="user-photo"
      :user="joinRequest.users"
    />
    <div class="name">
      <span>{{ joinRequest.users.firstName }} {{ joinRequest.users.lastName }}</span>
    </div>
    <img
      @click="decline(joinRequest)"
      src="@/assets/Decline.svg"
    />
    <img
      @click="approve(joinRequest)"
      src="@/assets/Accept.svg"
    />
  </div>
</template>

<script>
import UserPhoto from '@/components/shared/UserPhoto'

export default {
  name: 'ValidJoinRequest',
  components: { UserPhoto },
  props: {
    joinRequest: {
      type: Object,
      required: true
    }
  },
  methods: {
    approve (joinRequest) {
      this.$store.dispatch('approveJoinRequest', joinRequest)
    },
    decline (joinRequest) {
      this.$store.dispatch('declineJoinRequest', joinRequest)
    }
  }
}

</script>

<style scoped lang="scss">

.joinRequest {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 10px 5px 0;
  .user-photo {
    height: 3rem;
    border-radius: 100%;
  }
  .name {
    width:8rem;
    display: flex;
    font-size: 14px;
    text-align: left;
  }
  img {
    cursor: pointer;
    color: $primary-color;
    &:hover {
      text-decoration: underline;
    }
  }
}

</style>
